var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"scatter-root"},[_c('core-callout',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"legend",attrs:{"id":_vm.legendId}}),_c('div',{staticClass:"no-line-chart no-path-chart dashed-chart chart",attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }